module.exports = __webpack_public_path__ + "img/gradient-desktop.b0e97bb2.svg";